export const NO_COUNTERPARTY_VIEW_ROW_ID = "no-counterparty" as const;

export function getCounterpartyViewRowId(
    counterpartyId: string | null | undefined,
): string {
    return counterpartyId || NO_COUNTERPARTY_VIEW_ROW_ID;
}
